import React from 'react';
import { Trans } from '@lingui/macro';

export const SIMap: Record<string, JSX.Element> = {
  OENG: <Trans>"Energy</Trans>,
  OBMG: <Trans>Materialer</Trans>, // Basic Materials
  OING: <Trans>Industri</Trans>, // Industrials
  OCSG: <Trans>Forbruksvarer</Trans>, // Consumables
  OCDG: <Trans>Konsumvarer</Trans>, // Consumer Goods
  OHCG: <Trans>Health Care</Trans>,
  OFING: <Trans>Financials</Trans>,
  OTECG: <Trans>IT</Trans>,
  OTELG: <Trans>Telecommunication</Trans>,
  OUTG: <Trans>Forsyning</Trans>, // Supply
  OREG: <Trans>Eiendom</Trans>, // Properties
};

export default function mapSI(
  input: string | undefined,
): JSX.Element | undefined {
  if (!input) return undefined;

  const key = Object.keys(SIMap).find(key => {
    return key === input;
  });
  return key ? SIMap[key] : undefined;
}
